import { render, staticRenderFns } from "./CollaboratorsList.vue?vue&type=template&id=29bd0c69"
import script from "./CollaboratorsList.vue?vue&type=script&lang=js"
export * from "./CollaboratorsList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports